//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "PurchaseDetail",
  components: {
  },
  data() {
    return {
      purchaseOrderId:'',
      purchaseOrderSn:'',
      supplierName:'',
      tableData:[],
    }
  },
  created() {
    if(this.$route.query.purchaseOrderId){
      this.purchaseOrderId = this.$route.query.purchaseOrderId
      this.getMessage()
      this.getList()
    }
  },
  mounted() {
  },
  methods: {
    getMessage() {
      var params = {
        "purchaseOrderId": this.purchaseOrderId
      };
      axiosApi.queryPurchaseOrder(params).then(res => {
        this.purchaseOrderSn = res.content.purchaseOrderSn||''
        this.supplierName = res.content.supplierName||''
      })
    },
    getList() {
      var params = {
        "purchaseOrderId": this.purchaseOrderId,
        "start":0,
        "size":5,
        "orderKey":"crtTime",
        "desc":true,
      };
      axiosApi.pagePurchaseOrderGoodsList(params).then(res => {
        this.tableData = res.content.list||[]
      })
    },
    toMore(){
      this.$router.push({name:'purchaseDetailMore',query:{purchaseOrderId:this.purchaseOrderId}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/purchase/detail.vue